import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import * as Colors from "../Colors";
import { sortData } from "./ChartHelper";
import IsMobile from "../IsMobile";

// TODO: move this function outside to be used by all charts
function getTooltip({ active, payload }) {
  if (active) {
    return (
      <div className="Tooltip" style={{ color: payload[0].payload.fill }}>
        <p className="label">{`${payload[0].name}: ${Number.parseFloat(
          payload[0].value
        ).toFixed()}`}</p>
      </div>
    );
  }
}

export default function MyPie({ data, options }) {
  const [focusValue, setFocusValue] = useState(null);

  data = data ? data : [];
  data = sortData(data, options);

  const total = data.reduce((sum, current) => sum + current.value, 0);

  function MobileLegend() {
    return (
      <Legend
        layout="vertical"
        align="center"
        verticalAlign="bottom"
        onMouseOver={({ value }) => setFocusValue(value)}
        onMouseLeave={() => setFocusValue(null)}
        iconSize={20}
      />
    );
  }

  function DesktopLegend() {
    return (
      <Legend
        layout="vertical"
        align="right"
        verticalAlign="middle"
        width={180}
        onMouseOver={({ value }) => setFocusValue(value)}
        onMouseLeave={() => setFocusValue(null)}
        iconSize={20}
        iconType="square"
      />
    );
  }

  const margin = IsMobile()
    ? { top: 15, right: 40, bottom: 15, left: 40 }
    : { right: 10 };

  const colors =
    data.length > 4 ? Colors.COLOR_MAP_NO_YELLOW[data.length] : Colors.COLORS_4;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart margin={margin}>
        <Pie
          data={data}
          cx={"50%"}
          cy={"50%"}
          labelLine={false}
          label={(data) =>
            Number.parseFloat((data.payload.value * 100) / total).toPrecision(
              2
            ) + "%"
          }
          dataKey="value"
          isAnimationActive={false}
        >
          {data.map((entry, index) => {
            const opacity =
              focusValue === null || entry.name === focusValue ? 1 : 0.2;

            return (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
                style={{ opacity }}
              />
            );
          })}
        </Pie>
        <Tooltip content={(props, index) => getTooltip(props, index)} />
        {IsMobile() ? MobileLegend() : DesktopLegend()}
      </PieChart>
    </ResponsiveContainer>
  );
}
